import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Image } from '@codes/ui-kit/components/ui/image';
import { Moon, Sun } from 'lucide-react';

import { EnDarkIcon, EnHoverIcon, EnIcon, KrDarkIcon, KrHoverIcon, KrIcon } from '@codes/assets';
import { useTheme } from '@codes/theme';

export const ToggleOption = () => {
    const { t, i18n } = useTranslation();
    const { theme, setTheme } = useTheme();
    const [language, setLanguage] = useState<string>(i18n.language || 'en');

    const handleThemeChange = () => {
        setTheme(theme === 'light' ? 'dark' : 'light');
    };
    const toggleLanguage = () => {
        const newLanguage = language === 'en' ? 'ko' : 'en';
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
    };

    return (
        <div className="md:bg-white md:dark:bg-[#424242] h-[50px] flex md:rounded-full py-3 px-4 md:border-[0.6px] md:border-gray-300 md:shadow-custom">
            <div className="flex items-center justify-center gap-2">
                <button onClick={handleThemeChange}>
                    {theme === 'dark' ? (
                        <Sun className="w-6 h-6  hover:text-icon-hover" strokeWidth={1.5} />
                    ) : (
                        <Moon className="w-6 h-6 hover:text-icon-hover" strokeWidth={1.5} />
                    )}
                </button>
                <div className="text-base text-gray-200">|</div>
                <button className="relative shrink-0" onClick={toggleLanguage}>
                    <Image
                        className="w-6 h-6 block hover:opacity-0"
                        src={language === 'en' ? KrIcon : EnIcon}
                        darkSrc={language === 'en' ? KrDarkIcon : EnDarkIcon}
                        alt={language === 'en' ? 'Korean' : 'English'}
                    />
                    <Image
                        className="w-6 h-6 absolute top-0 left-0 opacity-0 hover:opacity-100"
                        src={language === 'en' ? KrHoverIcon : EnHoverIcon}
                        alt={language === 'en' ? 'Korean' : 'English'}
                    />
                </button>
            </div>
        </div>
    );
};
